import React from 'react';
import { Award } from 'lucide-react';
export function Reports() {
  return <div data-id="element-1413">
      <div className="mb-6" data-id="element-1414">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1415">Rapports</h1>
        <p className="text-gray-600" data-id="element-1416">
          Consultez les rapports et statistiques de votre équipe
        </p>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1417">
        <div className="flex items-center justify-between mb-6" data-id="element-1418">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-1419">
            Rapports d'équipe
          </h2>
          <Award className="h-5 w-5 text-blue-600" data-id="element-1420" />
        </div>
        <div className="text-center py-12" data-id="element-1421">
          <div className="mx-auto h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-1422">
            <Award className="h-6 w-6 text-gray-400" data-id="element-1423" />
          </div>
          <h3 className="text-gray-900 font-medium mb-1" data-id="element-1424">
            Fonctionnalité en développement
          </h3>
          <p className="text-gray-500" data-id="element-1425">
            Les rapports seront bientôt disponibles
          </p>
        </div>
      </div>
    </div>;
}